"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectServer = () => typeof navigator === "undefined";
//# sourceMappingURL=detectServer.js.map